exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".campaign-details[data-v-5ccc61f7]{padding-top:0}.type-label[data-v-5ccc61f7]{font-weight:600;text-transform:uppercase}", ""]);

// exports
